import './App.css';
import React from 'react';
import YouTubeMediaSuite from './YouTubeMediaSuite';
function App() {
  return (
    <div className="App">
      <YouTubeMediaSuite />
    </div>
  );
}

export default App;
